import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { SpaceRoleManagementScreen } from '@confluence/space-roles/entry-points/SpaceRoleManagementScreen.tsx';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import {
	SPACE_OVERVIEW,
	ADMIN_COMPANY_HUB_PERMISSIONS,
} from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { useSpaceRoleMode } from '@confluence/space-utils/entry-points/useSpaceRoleMode.ts';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';

export const SpaceMembersRoute = ({ name: routeName, params: { spaceKey } }: RouteMatch) => {
	const { isRbacEnabled, loading } = useSpaceRoleMode();
	const isCompanyHub = isCompanyHubSpaceKey(spaceKey);

	if (isCompanyHub && routeName !== ADMIN_COMPANY_HUB_PERMISSIONS.name) {
		return <Redirection name={ADMIN_COMPANY_HUB_PERMISSIONS.name} params={{ tab: 'users' }} />;
	}

	if (!loading && !isRbacEnabled) {
		return <Redirection name={SPACE_OVERVIEW.name} params={{ spaceKey }} />;
	}

	return <SpaceRoleManagementScreen spaceKey={spaceKey} />;
};

SpaceMembersRoute.NAVIGATION_PARAMS = ({ name, params: { spaceKey } }, isNav4Enabled) => ({
	Screen: {
		screenEvent: { name: 'spaceMembersScreen', id: spaceKey },
		pageState: {
			routeName: name,
			spaceKey,
		},
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
